import ReactGA from 'react-ga';

ReactGA.initialize('UA-128956350-1');

export default ReactGA;
